import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Type from "./Type";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home() {
  return (
    <section>
      {/* ----------------- HERO SECTION ----------------- */}
      <Container fluid className="home-section px-0 py-0" id="home">
        <Particle />
        <Container className="home-content">
          {/* Remove default Bootstrap gutter spacing */}
          <Row className="g-0 align-items-center">
            {/* Text Column */}
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hey there!
              </h1>

              <h1 className="heading-name">
                I'm <strong className="main-name">Renee.</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            {/* Image Column */}
            <Col md={4} className="myAvatar d-flex justify-content-center">
              <Tilt>
                <img
                  src={myImg}
                  className="img-fluid"
                  alt="avatar"
                  style={{ width: "100%", maxWidth: "none" }}
                />
              </Tilt>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* ----- SOCIAL LINKS ----- */}
      <Container>
        <Row style={{ paddingTop: "100px", paddingBottom: "20px" }}>
          <Col md={12} className="home-about-social">
            <h1>Find <span className="teal">me</span> on</h1>

            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/renee-runyon"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="GitHub icon"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/renee-runyon/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="LinkedIn icon"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/littleorangehellcat"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="Instagram icon"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
